import { render, staticRenderFns } from "./ScoreSubAdmin.vue?vue&type=template&id=44c0c095&scoped=true&"
import script from "./ScoreSubAdmin.vue?vue&type=script&lang=js&"
export * from "./ScoreSubAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ScoreSubAdmin.vue?vue&type=style&index=0&id=44c0c095&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c0c095",
  null
  
)

export default component.exports